import { fetchAudiencesFailure } from "../actions/audiences";
import {
  fetchPBWorkspaceReportRequest,
  fetchPBWorkspaceReportSuccess,
  markFavUnFavReportRequest,
  markFavUnFavReportSuccess,
  markFavorite,
  markFavoriteFailure,
  reportFailure,
  resetReportDetails,
  searchReportFailure,
  searchReportRequest,
  searchReportSuccess,
  selectedReportDetails,
  viewAadReportFailure,
  viewAadReportSuccess,
  viewReportRequest,
  viewReportSuccess,
} from "../actions/report";

export const getInitialState = () => ({
  isFetching: false,
  isMarkFavorite: false,
  favouritesReports: [],
  workspaces: [],
  reportDetails: null,
  aadReportDetails: null,
  selectedReport: null,
  reportError: null,
  isSearchReport: false,
  searchReports: [],
  isFetchingReport: false,
});

const reportReducer = (state: any = getInitialState(), action: any) => {
  switch (action.type) {
    case fetchPBWorkspaceReportRequest:
      return { ...state, isFetchingReport: true };
    case viewReportRequest:
    case markFavorite:
      return { ...state, isMarkFavorite: true };
    case searchReportRequest:
      return { ...state, isSearchReport: true };
    case markFavUnFavReportRequest:
      return { ...state, isFetching: true };
    case fetchPBWorkspaceReportSuccess:
      return {
        ...state,
        isFetchingReport: false,
        workspaces: action.workspaces,
      };
    case viewReportSuccess:
      return {
        ...state,
        reportDetails: action.reportdetails,
        isFetching: false,
      };
    case resetReportDetails:
      return {
        ...state,
        reportDetails: null,
        isFetching: false,
      };
    case selectedReportDetails:
      return {
        ...state,
        selectedReport: action.selectedReport,
      };
    case markFavUnFavReportSuccess:
      // Ensure unique reportName in favouritesReports
      const uniqueReports = [];
      const seenNames = new Set();
      for (const report of action.reports) {
        if (!seenNames.has(report.reportName)) {
          uniqueReports.push(report);
          seenNames.add(report.reportName);
        }
      }
      return {
        ...state,
        isMarkFavorite: false,
        favouritesReports: uniqueReports,
      };
    case fetchAudiencesFailure:
    case reportFailure:
      return { ...state, isFetching: false, isFetchingReport: false };
    case markFavoriteFailure:
      return { ...state, isMarkFavorite: false };
    case viewAadReportSuccess:
      return {
        ...state,
        aadReportDetails: action.reportdetails,
        reportError: null,
        isFetching: false,
      };
    case viewAadReportFailure:
      return {
        ...state,
        reportError: action.reportError,
        isFetching: false,
      };
    case searchReportSuccess:
      return {
        ...state,
        searchReports: action.searchReports,
        isSearchReport: false,
      };
    case searchReportFailure:
      return {
        ...state,
        isSearchReport: false,
      };
    default:
      return state;
  }
};

export default reportReducer;
